import { h, Component } from 'preact';

import { Loading } from 'lib/mkjs';
import ConnectionRequest from "entities/connectionrequest";
import ContactInfo from "entities/contactinfo";
import {
	FatHeader,
	CreateUserAndAcceptInvite,
	LoginAndAcceptInvite
} from 'lib/townshend/components/townshendentities';
import { contactInfoUrl } from '../addressbook';

export function getConnectionRequestUrl(contactInfoId) {
	return `/contacts/${contactInfoId}/request`
}

export default class ConnectionRequestView extends ConnectionRequest {

	fetch(id) {
		return this.getApi().list({
			'personalContactCausingRequest.id': this.props.contactId
		})
	}

	renderView(subject) {
		if (subject && subject.length) {
			// if request exists, show status
			let activeRequests = subject.filter(req=>req.status === 'ACTIVE');
			let acceptedRequests = subject.filter(req=>req.status === 'ACCEPTED' && req.resultConnection);
			if (activeRequests.length >= 1) {
				// show connectionRequest
				return <ConnectionRequestStatusView subject={activeRequests[0]} {...this.props} />
			} else if (acceptedRequests.length >= 1) {
				return <div>
					This connection request has been accepted. View the
					connection <a href={contactInfoUrl({connection:acceptedRequests[0].resultConnection})}>here</a>.
				</div>
			}
		}
		// if no request, show request creation
		return <ConnectionRequestCreationView creating onCreate={()=>this.fetchSubject()} {...this.props} />
	}
}

class ConnectionRequestCreationView extends ConnectionRequest {


	getCreateFields() {
		return {}
	}

	getEditTitle(isUpdate, entity) {
		return '';
	}

	renderCreate() {
		//TODO validate identifier and type being passed via path
		return <div>
			<h1>Connect through Addy</h1>
			<p class="m-2">Click <b>Generate Request</b> and we will generate a connection link for you to share with
				<ContactInfoName {...this.props} id={this.props.contactId} creating={false} inline />.</p>
			<p class="m-2">Once you're connected, you'll never have to worry about having out-of-date contact info again!</p>
			{super.renderCreate()}
		</div>
		//TODO success message: Verification sent! Enter your verification code below or click on the link in the email to get verified!
		//for on linked page: Almost done! click "verify" to complete the process (created ContactIdentity from the verification)
	}

	getEditButtonText(isUpdate) {
		return isUpdate ? 'Update' : 'Generate Request!';
	}

	getViewUrl(item) {
		return getConnectionRequestUrl(this.props.contactId);
	}

	prepareCreate(subject) {
		return {
			requestor: {
				id: this.props.contactEntity.id
			},
			requestee: null, // This should be empty
			personalContactCausingRequest: {
				id: this.props.contactId
			},
			desire: 'CONNECTION' // TODO make this dynamic when you have different request types
		};
	}
}

class ConnectionRequestStatusView extends ConnectionRequest {

	renderView(subject) {
		if (subject.desire === "CONNECTION") {
			// show message stating no connection yet and copyable link
			/**
			Connection Request
			date created
			who
			status
			link
			 */
			if (subject.code) {
				return <div>
					<h1>Connection Request</h1>
					<p>You've create a connection request for <ContactInfoName
							{...this.props} id={this.props.contactId} subject={null} inline />.</p>
					<p><Copyable content={generateConnectionRequestLink(subject)} /></p>
					<p>Send them this link and never worry about having out-of-date contact info again!</p>
				</div>
			} else {
				return <div>
					<h1>Connection Request</h1>
					<p>You've sent a connection request to <ContactInfoName
							{...this.props} id={this.props.contactId} subject={null} inline /> through Addy.</p>
					<p>We'll let you know once the request is accepted!</p>
				</div>
			}
		} else if (subject.desire === "PUSH_INFORMATION") {
			// TODO show copyable link as well as ability to cancel or update to
		} else {
			// TODO user is requesting info. show link and show any info and when it was updated.
		}
		return super.renderView(subject);
	}
}

export function generateConnectionRequestLink(connectionRequest) {
	return `${window.location.origin}/r/${connectionRequest.id}/${connectionRequest.code}`
}

export class AcceptConnectionRequest extends ConnectionRequest {

		fetch(id) {
			return this.getApi().get(id, {
				code: this.props.connectionRequestCode
			});
		}

		getSubjectIdPropKey() {
			return 'connectionRequestId';
		}

		//TODO handle error better: the current message is just 'Invalid form submission.'
		renderView(subject) {
			let message, form;
			const connectMessage = `Connect to ${subject.requestor.contactInfo.info.name} on Addy`;
			if (this.props.isLoading) {
				return <Loading />
			} else if (this.props.contactEntity) {
				if (this.props.contactEntity.id === subject.requestor.id) {
					if (subject.requestee && subject.status === 'ACCEPTED') {
						message = <FatHeader content="This Connection Request has been accepted." />
						// TODO click here to go to connection
					} else {
						message = <FatHeader content="This is a Connection Request that you created." />
						form = <p>send this url to <ContactInfoName {...this.props} id={subject.personalContactCausingRequest.id} creating={false} inline />.</p>
						// TODO add more info (like time), the ability to cancel, and links.
					}
				} else {
					if (subject.requestee) {
						if (this.props.contactEntity.id === subject.requestee.id) {
							if (subject.status === 'ACCEPTED') {
								message = <FatHeader content='You have accepted this connection request.' />;
							} else if (subject.status === 'IGNORED') {
								message = <FatHeader content='You ignored this connection request.' />;
							} else {
								console.error('unrecognized status for connection request', subject)
							}
						} else {
							message = <FatHeader content='This connection request has been accepted by someone else' />;
						}
					} else {
						let action = (status) => {
							this.submitUpdate(subject.id, {
								status,
								code: this.props.connectionRequestCode,
								requestee: {
									id: this.props.contactEntity.id
								}
							}).then(()=>{
								this.props.onAccept();
							});
						}
						message = <FatHeader content={connectMessage} />;
						form = <button type="button" class="btn btn-lg btn-success m-5" onClick={()=>action('ACCEPTED')}>accept connection request</button>;
					}
				}
			} else {
				message = <FatHeader content={connectMessage} />
				const invite = subject.invitation ? subject.invitation.id : null;
				const code = subject.invitation ? subject.invitation.code : null;
				form = <div>
					<CreateUserAndAcceptInvite {...this.props} creating hideCancel inviteId={invite} code={code} />
					<LoginAndAcceptInvite {...this.props} hideCreate hideForgot />
				</div>
			}
			return <div>
				{message}
				{form}
			</div>
		}
	}

// TODO improve this and move it to mkjs
class Copyable extends Component {
	render() {
		return this.props.content;
	}
}

class ContactInfoName extends ContactInfo {
	renderView(subject) {
		return <b>{subject.info.name}</b>
	}
}



// WEBPACK FOOTER //
// ./components/elements/connectionrequest/index.js